import { memo } from "react";
import {
  Circle as _Circle,
  Path as _Path,
  Rect as _Rect,
  Svg as _Svg
} from "react-native-svg";
import { themed } from "../../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return <_Svg
    viewBox="0 0 256 256"
    {...otherProps}
    height={size}
    width={size}
    fill={`${color}`}
  >
    <_Rect width="256" height="256" fill="none" />
    <_Path d="M128,24A104.1,104.1,0,0,0,24.1,132.1c2.1,54.7,47,98.8,101.8,99.9a104,104,0,0,0,91.4-50.8,4,4,0,0,0-4.1-6,52.5,52.5,0,0,1-9.2.8c-18.3,0-28.5-8-33.9-14.7a43.9,43.9,0,0,1-3.4-5A48,48,0,1,1,128,80a47.4,47.4,0,0,1,32,12.3v-4a8.2,8.2,0,0,1,7.5-8.3,8,8,0,0,1,8.5,8v40c0,14.6,4.9,32,28,32s27.6-16.2,28-30.5V128A104.1,104.1,0,0,0,128,24Z" />
    <_Circle cx="128" cy="128" r="32" fill={`${color}`} />
  </_Svg>;
};
Icon.displayName = "AtFill";
const AtFill = memo(themed(Icon));
export {
  AtFill
};
//# sourceMappingURL=at-fill.js.map
